import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../services/storage-service';
import { AppUrl } from '../../appUrl';
import { ThaidatePipe } from '../../pipe/thaidate-pipe';
import moment from 'moment';
import { TranslateModule } from '../../shareds/translate/translate.module';

@Component({
  selector: 'app-booking-success',
  standalone: true,
  imports: [CommonModule, ThaidatePipe, TranslateModule],
  templateUrl: './booking-success.component.html',
  styleUrls: ['./booking-success.component.css']
})
export class BookingSuccessComponent implements OnInit {
  private router = inject(Router);
  private ac = inject(ActivatedRoute);
  private st = inject(StorageService);

  bookingData = signal<any>(null);
  bookingResult = signal<any>(null);
  contactEmail = signal('');

  ngOnInit() {
    const bd = this.st.getSession('lastBookingData');
    const br = this.st.getSession('lastBookingResult');
    const email = this.st.getSession('lastContactEmail');
    if (bd) this.bookingData.set(JSON.parse(bd));
    if (br) this.bookingResult.set(JSON.parse(br));
    if (email) this.contactEmail.set(email);
  }

  goHome() {
    // อ่าน branchId จาก lastBookingData ก่อน clear (reliable กว่า listRoomState)
    let confirmedBranchId: string | null = null;
    try {
      const lbd = this.st.getSession('lastBookingData');
      if (lbd) confirmedBranchId = JSON.parse(lbd)?.branchId ?? null;
    } catch {}

    this.st.removeSession('lastBookingData');
    this.st.removeSession('lastBookingResult');
    this.st.removeSession('lastContactEmail');
    this.st.removeSession('bookingData');
    this.st.removeSession('customerInfo');

    // reset listRoomState: คง branchId, รีเซ็ตค่าอื่นเป็น default
    try {
      const saved = this.st.getSession('listRoomState');
      const s = saved ? JSON.parse(saved) : {};
      if (confirmedBranchId) s.branchId = confirmedBranchId;
      s.checkIn = moment().format('YYYY-MM-DD');
      s.checkOut = moment().add(1, 'day').format('YYYY-MM-DD');
      s.totalAdultsAmount = 2;
      s.totalChildrenAmount = 0;
      s.totalGuestAmount = 2;
      s.totalRoomAmount = 1;
      s.planQtyMap = {};
      s.planPriceMap = {};
      s.snapshotAdults = null;
      s.snapshotChildren = null;
      this.st.setSession('listRoomState', JSON.stringify(s));
    } catch {}

    this.router.navigate(['/', AppUrl.list_room, this.ac.snapshot.params['app-id']]);
  }
}
